export const QUANTITY = 'QUANTITY';

const KNOWN_ABBREVIATIONS = {
  "GRAM" : "g",
  "GRAMS" : "g",
  "QUANTITY" : "qty",
  "OUNCE" : "oz",
  "OUNCES" : "oz",
  "POUND" : "lb",
  "POUNDS" : "lb",

};

export const tryToAbbreviate = (string) => {
  if (typeof string !== "string") return "";

  const abbreviated = KNOWN_ABBREVIATIONS[string.toUpperCase()];
  if (abbreviated) return abbreviated;

  return string;
};


// WEBPACK FOOTER //
// ./src/selectors/string_selectors.js